import { updateState } from './admin-globals.js';
import { authHeaders } from './admin-auth.js';

/** Evita crear dos YT.Player si la API llama dos veces al callback */
let _fetcherPlayerCreated = false;

/** Extrae ID de 11 caracteres desde URL o texto plano (watch, shorts, embed, youtu.be) */
export function normalizeYoutubeVideoId(input) {
  if (input == null) return '';
  const s = String(input).trim();
  if (/^[A-Za-z0-9_-]{11}$/.test(s)) return s;
  const m = s.match(
    /(?:v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/shorts\/)([A-Za-z0-9_-]{11})/i
  );
  return m ? m[1] : '';
}

async function durationFromBackend(videoId) {
  const id = normalizeYoutubeVideoId(videoId);
  if (!id) return 0;
  try {
    const r = await fetch(
      `/api/youtube/duration?id=${encodeURIComponent(id)}&_=${Date.now()}`,
      { cache: 'no-store', credentials: 'same-origin', headers: authHeaders() }
    );
    const text = await r.text();
    let j;
    try {
      j = JSON.parse(text);
    } catch {
      console.warn('[RapTV Admin] /api/youtube/duration no JSON:', text.slice(0, 160));
      return 0;
    }
    if (!r.ok) {
      console.warn('[RapTV Admin] duration API', r.status, j);
      return 0;
    }
    const s = Number(j.duration_seconds);
    return Number.isFinite(s) && s > 0 ? Math.round(s) : 0;
  } catch (e) {
    console.warn('[RapTV Admin] duration fetch error', e);
    return 0;
  }
}

/**
 * Crea el reproductor oculto para leer duraciones vía IFrame API (fallback si no hay Data API).
 */
export function onYouTubeIframeAPIReady() {
  if (typeof YT === 'undefined' || !YT.Player || _fetcherPlayerCreated) return;
  _fetcherPlayerCreated = true;
  console.log('[RapTV Admin] YT fetcher player creating…');

  new YT.Player('yt-fetcher-player', {
    height: '1',
    width: '1',
    videoId: 'dQw4w9WgXcQ',
    playerVars: {
      autoplay: 0,
      controls: 0,
      enablejsapi: 1,
      modestbranding: 1,
      origin: window.location.origin,
    },
    events: {
      onReady(e) {
        updateState('ytFetcher', e.target);
        updateState('ytFetcherReady', true);
        if (window.pendingFetchId) {
          try {
            e.target.cueVideoById(window.pendingFetchId);
          } catch (err) {
            console.warn('[RapTV Admin] cueVideoById on ready failed:', err);
          }
        }
      },
      onStateChange(e) {
        if (e.data !== YT.PlayerState.CUED || !window.onDurationFetched) return;
        const player = e.target;
        let attempts = 0;
        const deliver = () => {
          const cb = window.onDurationFetched;
          if (!cb) return;
          let d = 0;
          try {
            d = player.getDuration();
          } catch (_) {}
          if (d > 0 && isFinite(d)) {
            cb(d);
            return;
          }
          attempts++;
          if (attempts >= 40) {
            cb(0);
            return;
          }
          setTimeout(deliver, 100);
        };
        deliver();
      },
    },
  });
}

/**
 * Duración en segundos: primero servidor (Data API), si falla iframe oculto.
 */
export async function fetchDuration(videoId) {
  const id = normalizeYoutubeVideoId(videoId);
  if (!id) return 0;

  const fromApi = await durationFromBackend(id);
  if (fromApi > 0) return fromApi;

  return new Promise((resolve) => {
    let settled = false;
    const finish = (d) => {
      if (settled) return;
      settled = true;
      try {
        window.onDurationFetched = null;
      } catch (_) {}
      resolve(d > 0 && isFinite(d) ? d : 0);
    };

    const t = setTimeout(() => finish(0), 12000);

    window.onDurationFetched = (d) => {
      clearTimeout(t);
      finish(typeof d === 'number' ? d : 0);
    };

    const runCue = () => {
      const p = window.ytFetcher;
      if (window.ytFetcherReady && p && typeof p.cueVideoById === 'function') {
        try {
          p.cueVideoById(id);
        } catch (err) {
          console.warn('[RapTV Admin] cueVideoById failed:', err);
          clearTimeout(t);
          finish(0);
        }
        return true;
      }
      window.pendingFetchId = id;
      return false;
    };

    if (!runCue()) {
      let n = 0;
      const iv = setInterval(() => {
        n++;
        if (runCue()) {
          clearInterval(iv);
        } else if (n >= 120) {
          clearInterval(iv);
          clearTimeout(t);
          finish(0);
        }
      }, 100);
    }
  });
}
